export default __webpack_public_path__ + "static/Fellix-MediumItalic-ef63ff229c40d52b464cfbb92cbe477e.otf";